import { render, staticRenderFns } from "./choose-one-slider.vue?vue&type=template&id=9a37b336"
import script from "./choose-one-slider.vue?vue&type=script&lang=js"
export * from "./choose-one-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports